import { request } from './api';

export const authService = {
  // تابع خروج: هم سمت سرور و هم سمت کلاینت
  logout: async () => {
    const token = localStorage.getItem('token');
    
    if (token) {
      try {
        // 1. درخواست به سرور برای سوزاندن توکن
        await request('/logout.php', 'POST', {}, {
             'Authorization': `Bearer ${token}`
        });
      } catch (error) {
        console.error("Logout API Error:", error);
      }
    }

    // 2. پاکسازی سمت کلاینت
    localStorage.removeItem('token');
    // اگر دیتای دیگری مثل user_info دارید هم اینجا پاک کنید
  },

  // تابع چک کردن لاگین بودن (برای روت‌های محافظت شده)
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};